(function() {
  'use strict';

  // ── Phone input mask: (XXX) XXX-XXXX ──────────────────────────
  var phoneEl = document.getElementById('profile-phone');
  if (phoneEl) {
    // Format initial value from E.164 to display
    formatPhoneDisplay(phoneEl);

    phoneEl.addEventListener('input', function() {
      var raw = phoneEl.value.replace(/\D/g, '');
      // Strip leading 1 for display
      if (raw.length > 10 && raw.charAt(0) === '1') raw = raw.substring(1);
      if (raw.length > 10) raw = raw.substring(0, 10);
      var formatted = '';
      if (raw.length > 0) formatted = '(' + raw.substring(0, 3);
      if (raw.length >= 3) formatted += ') ';
      if (raw.length > 3) formatted += raw.substring(3, 6);
      if (raw.length >= 6) formatted += '-';
      if (raw.length > 6) formatted += raw.substring(6, 10);
      phoneEl.value = formatted;
    });
  }

  function formatPhoneDisplay(el) {
    var raw = (el.value || '').replace(/\D/g, '');
    if (raw.length === 0) return;
    if (raw.length === 11 && raw.charAt(0) === '1') raw = raw.substring(1);
    if (raw.length === 10) {
      el.value = '(' + raw.substring(0, 3) + ') ' + raw.substring(3, 6) + '-' + raw.substring(6);
    }
  }

  // ── Save profile ──────────────────────────────────────────────
  window.__profileSave = function() {
    var firstName = document.getElementById('profile-firstName').value.trim();
    var lastName = document.getElementById('profile-lastName').value.trim();
    var email = document.getElementById('profile-email').value.trim();

    if (!firstName || !lastName) {
      __acctToast('First name and last name are required.', 'error');
      return;
    }
    if (!email || email.indexOf('@') === -1) {
      __acctToast('Please enter a valid email address.', 'error');
      return;
    }

    var btn = document.getElementById('profile-save-btn');
    var txt = document.getElementById('profile-save-text');
    var spin = document.getElementById('profile-save-spinner');
    btn.disabled = true;
    txt.textContent = 'Saving...';
    spin.style.display = '';

    var payload = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: document.getElementById('profile-phone').value
    };

    fetch('/apps/purchase-history/profile', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      btn.disabled = false;
      txt.textContent = 'Save changes';
      spin.style.display = 'none';

      if (data.error) {
        __acctToast(data.error, 'error');
      } else {
        __acctToast('Profile updated successfully.');
      }
    })
    .catch(function(err) {
      btn.disabled = false;
      txt.textContent = 'Save changes';
      spin.style.display = 'none';
      __acctToast('Something went wrong. Please try again.', 'error');
      console.error('Profile save error:', err);
    });
  };
})();
